module.exports = __webpack_public_path__ + "static/media/b3.448a97ba.png";